export const entertainmentData = {
  movies: [
    { id: 'm1', title: 'Dune: Part Two', mood: 'Epic / Sci-Fi', tag: 'Blockbuster', scene: 'Lively' },
    { id: 'm2', title: 'No More Bets', mood: 'Suspense / Thrilling', tag: 'Top Rated', scene: 'Thrilling' },
    { id: 'm3', title: 'Soul', mood: 'Heartwarming / Light', tag: 'Feel-good', scene: 'Soothing' },
    { id: 'm4', title: 'Parasite', mood: 'Twisty / Social', tag: 'Discussion', scene: 'Thoughtful' },
  ],
  music: [
    { id: 'mu1', title: 'City Pop · Night Ride', mood: 'Commute energy', tag: 'Playlist', scene: 'Relax' },
    { id: 'mu2', title: 'Lo-Fi Chill', mood: 'Study focus', tag: 'Instrumental', scene: 'Focused' },
    { id: 'mu3', title: 'Indie Folk Picks', mood: 'Relaxed chat', tag: 'Vibe', scene: 'Soothing' },
    { id: 'mu4', title: 'EDM Hype', mood: 'Party / High energy', tag: 'Hype tracks', scene: 'Lively' },
  ],
  games: [
    { id: 'g1', title: 'Switch Party Games', mood: 'Easy for everyone', tag: 'Local multiplayer', scene: 'Lively' },
    { id: 'g2', title: 'Just Dance', mood: 'Move and break the ice', tag: 'Dance', scene: 'Upbeat' },
    { id: 'g3', title: 'Board Game: Dixit', mood: 'Imaginative social', tag: 'Tabletop', scene: 'Soothing' },
    { id: 'g4', title: 'Pictionary', mood: 'Light & hilarious', tag: 'Party', scene: 'Party' },
  ],
};

export const truthList = [
  'What was the last hilariously embarrassing moment you had?',
  'What is a useless but fun skill you secretly have?',
  'What is one ability you wish you could learn instantly?',
];

export const dareList = [
  'Act out a classic line from a movie or animation.',
  'Spend 30 seconds praising one good trait of everyone here.',
  'Play a random song on your phone and explain why you recommend it.',
];

export const spinOptions = [
  'What to eat',
  'Watch a movie',
  'Play board games',
  'Sing karaoke',
  'Milk tea run',
  'Night run',
  'Take photos',
];

